module.exports = __webpack_public_path__ + "media/images/writer/emailer/facebook-icon-5197e643b224900baa051878e3426d9d.png";